/** @prettier */

/**
 * ゲートウェイ支払いユーザのサイト権限変更、削除処理時のエラーダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {PrimaryButton} from './BasicButton';

/**
 * ゲートウェイ支払いユーザのサイト権限変更、削除処理時のエラーダイアログ
 * @param props props
 * - errorCode エラーコード
 * - gwNameList 対象ユーザが支払いユーザに登録されているゲートウェイの名前リスト
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - id ID
 * @returns JSX
 */
const ChangePayingUserAuthorityMessage = (props: {
  errorCode: string;
  gwNameList: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
}) => {
  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
  };

  /**
   * メッセージ文決定関数
   * @return エラーメッセージ
   */
  const selectErrorMessage = () => {
    if (props.errorCode === 'CHANGE_ADMIN_USER_FORBIDDEN') {
      return trans(
        'ChangePayingUserAuthorityMessage.errDialog.msg.changeAdmin',
        {
          gwList: props.gwNameList,
        }
      );
    } else {
      return trans(
        'ChangePayingUserAuthorityMessage.errDialog.msg.deleteAdmin',
        {
          gwList: props.gwNameList,
        }
      );
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title">
      <DialogTitle
        id="form-dialog-title"
        className="siteSecurity__errorDialog__title">
        {trans('ChangePayingUserAuthorityMessage.errDialog.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText
          id="mv-processError-text"
          className="siteSecurity__errorDialog__contentText">
          {selectErrorMessage()}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans(
            'ChangePayingUserAuthorityMessage.errDialog.buttonTxt.ok'
          )}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default ChangePayingUserAuthorityMessage;
